import axios from "axios";
import { store } from "../store";
import { logout, dispatchError } from "../action";

export const BASE_URL_SOCKET = "https://aimovementapi.herokuapp.com/";
// export const BASE_URL = "https://aimovementapi.herokuapp.com/";
export const BASE_URL = "https://testbackendaimovementwebapp.onrender.com/";
export const BASE_URL_DEV = "https://aimovementapi.herokuapp.com/";

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status, statusText } = err.response;
    switch (status) {
      case 503:
      case 500:
      case 506:
        store.dispatch(dispatchError({ status, statusText }));
        break;
      // case 403:
      //   store.dispatch(logout());
      //   break;
      default:
        break;
    }
    if (err.response) {
      console.log("Yes it has expired");
      console.log(err.response);
      if (err.response.data.message === "Unauthenticated") {
        console.log("Yes it has expired");
        // store.dispatch(logout());
      }
    }
    return Promise.reject(err);
  }
);

export default instance;
